import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch,useAppSelector } from '../../../app/hooks';
import { getAccountExpensePolicyCategoryByCategoryIdAsync,UpdateAccountExpensePolicyCategorybyCategoryAsync,updateSorting} from './expensePolicyDetailSlice';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import ExpensePolicyCategoryForm from './ExpensePolicyCategoryForm';
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { setItemStatus, getValueFromResource, FormatInvoiceDecimalNumber} from '../../../common/timeLiveFunction';


const itemClass = 'ms-1 ms-lg-0';

const ExpensePolicyDetailItem = (props: any) => {
    const { expensePolicyDetailList, modelRef, t, onopenModal, closeModalPolicyCategory, IsEdit, IsDelete } = props;    
    const { cultureInfoName, decimalPlaces } = useAppSelector((state) => state.globalState);

    const dispatch = useAppDispatch();
    const { isLoading,sortOrder, sortColumn, pageSize} = useAppSelector((state) => state.expensePolicyDetail);
    // const [pageSize,setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    // const handlePageChange = (pageNumber: any) => {
    //     setCurrentPage(pageNumber);
    // };

    const onEditClick = (AccountExpensePolicyCategoryId: number, AccountExpensePolicyId: string) => {
        dispatch(getAccountExpensePolicyCategoryByCategoryIdAsync({AccountExpensePolicyCategoryId:AccountExpensePolicyCategoryId,AccountExpensePolicyId:AccountExpensePolicyId}))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('getBillingTypeByIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }


    const handleIsDisabledChange = (e: any, AccountExpensePolicyCategory: any) => {
        const { checked } = e.target;
        const foundIndex = expensePolicyDetailList.findIndex((item: any) => item.AccountExpensePolicyCategoryId === AccountExpensePolicyCategory.AccountExpensePolicyCategoryId);
        if (foundIndex !== -1) {
            const foundItem = expensePolicyDetailList[foundIndex];
            const { ...updatedItem } = foundItem;
            updatedItem.IsDisabledCategory = checked;
            const modifiedList = [...expensePolicyDetailList.slice(0, foundIndex), updatedItem, ...expensePolicyDetailList.slice(foundIndex + 1)];
            dispatch(UpdateAccountExpensePolicyCategorybyCategoryAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Expense Category Limits Update Successfully", 'Success', "success", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }
    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle"  >
                    <th style={{ width: '20%' }}> 
                        {/* {t('Category Name')} */}
                        {getValueFromResource('Category Name',dispatch, t)}
                        {sortColumn === 'AccountExpenseName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountExpenseName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountExpenseName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountExpenseName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountExpenseName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Expense Amount Limit')} */}
                            {getValueFromResource('Expense Amount Limit',dispatch, t)}
                        {sortColumn === 'ExpenseAmountLimit' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpenseAmountLimit") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpenseAmountLimit") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpenseAmountLimit") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpenseAmountLimit") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Receipt Required Limit')} */}
                            {getValueFromResource('Receipt Required Limit',dispatch, t)}
                        {sortColumn === 'ReceiptRequiredLimit' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ReceiptRequiredLimit") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ReceiptRequiredLimit") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ReceiptRequiredLimit") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ReceiptRequiredLimit") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Description Required')} */}
                            {getValueFromResource('Description Required',dispatch, t)}
                        {sortColumn === 'IsDescriptionRequired' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDescriptionRequired") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDescriptionRequired") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDescriptionRequired") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDescriptionRequired") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Active / Inactive')} */}
                            {getValueFromResource('Active / Inactive',dispatch, t)}
                            {sortColumn === 'IsDisabledCategory' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabledCategory") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabledCategory") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabledCategory") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabledCategory") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-15'></th>
                    </tr>
                </thead>
                <tbody>
                   
                    {expensePolicyDetailList.length > 0 && expensePolicyDetailList.map((expensePolicyDetail: any, i: any) => (
                        <tr key={i}>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor' onClick={() => { onEditClick(expensePolicyDetail.AccountExpensePolicyCategoryId, expensePolicyDetail.AccountExpensePolicyId) }}>
                                <span className="d-block"
                                >{expensePolicyDetail.AccountExpenseName}</span>
                            </td>
                            <td>
                                {FormatInvoiceDecimalNumber(cultureInfoName.toString(), expensePolicyDetail.ExpenseAmountLimit, decimalPlaces)}
                            </td>
                            <td >
                                {FormatInvoiceDecimalNumber(cultureInfoName.toString(), expensePolicyDetail.ReceiptRequiredLimit, decimalPlaces)}
                            </td>
                            <td >
                                {expensePolicyDetail.IsDescriptionRequired === true ? 'Yes' : "No"}
                            </td>

                            <td className='text-center'>

                                <div className="form-check form-switch form-check-custom">
                                    {/* <input
                                        type="checkbox"
                                        className="form-check-input custom-padding-right h-15px w-30px"
                                        id="IsDisabledCategory"
                                        checked={expensePolicyDetail.IsDisabledCategory === true ? true : false}
                                        onChange={(e) => { handleIsDisabledChange(e, expensePolicyDetail) }}
                                    /> */}
                                    <td>
                                            <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(expensePolicyDetail.IsDisabledCategory ? (expensePolicyDetail.IsDisabledCategory === false ? "Active" : "InActive") : "Active") )}>
                                                {/* {expensePolicyDetail.IsDisabledCategory === false ? "Active" : "InActive"} */}
                                                {(expensePolicyDetail.IsDisabledCategory ? (expensePolicyDetail.IsDisabledCategory === false ? "Active" : "InActive") : "Active")}
                                            </span>
                                        </td>
                                </div>
                            </td>

                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onEditClick(expensePolicyDetail.AccountExpensePolicyCategoryId, expensePolicyDetail.AccountExpensePolicyId) }}
                                                        >
                                                            <span className="menu-icon custom-menu">
                                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Edit')}`} */}
                                                                {getValueFromResource('Edit',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {expensePolicyDetailList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
    </>


    )
}

export default ExpensePolicyDetailItem